/** True when the event started (or landed) inside any of the given elements.

A `contains(target)` check misses portaled lists, scrollbar thumbs, and the
case where mousedown and mouseup have different targets. `composedPath()`
is the hit list the browser actually used.
*/
export function eventInside(e: Event, ...els: Array<EventTarget | null>): boolean {
  const path = e.composedPath();
  return els.some((el) => el != null && path.includes(el));
}

/** Close a menu on Escape. Capture + stop so the open list goes first, and a
 *  parent dialog that also listens (alert modal, …) stays put. */
export function onEscapeKey(close: () => void) {
  return (e: KeyboardEvent) => {
    if (e.key !== "Escape") return;
    e.preventDefault();
    e.stopPropagation();
    close();
  };
}
